import { useMemo } from 'react';

const BASE_URL = 'https://www.airthings.com';
const DEFAULT = '/en';
const UTM_CAMPAIGN = 'App_ecom_MVP';

type Store = {
  country: string;
  language?: string;
  slug: string;
};

const STORES: ReadonlyArray<Store> = [
  { country: 'CA', slug: '/en-ca', language: 'en' },
  { country: 'CA', slug: '/fr-ca', language: 'fr' },
  { country: 'DK', slug: '/da' },
  { country: 'GB', slug: '/en-gb' },
  { country: 'NO', slug: '/no' },
  { country: 'SE', slug: '/sv' },
  { country: 'US', slug: '' },
] as const;

const STORES_BY_COUNTRY = STORES.reduce((acc, store) => {
  const languages = acc[store.country] || [];
  acc[store.country] = languages.concat([store]);
  return acc;
}, {} as Record<string, Store[]>);

const guessStore = (languages: ReadonlyArray<string>): Store | undefined => {
  for (const lang of languages) {
    const [language, country] = lang.split('-');
    const matchingStores = STORES_BY_COUNTRY[country];

    if (!matchingStores) {
      continue;
    }

    return (
      matchingStores.find(store => store.language == language) ??
      matchingStores[0]
    );
  }
};

export const guessStoreUrl = (languages: ReadonlyArray<string>): string => {
  const store = guessStore(languages);
  return store?.slug ?? DEFAULT;
};

const guessUTMSource = (platform: string) => {
  // https://developer.mozilla.org/en-US/docs/Web/API/Navigator/platform#examples
  if (platform.indexOf('Mac') === 0 || platform === 'iPhone') {
    return 'airthings_app_ios';
  }

  return 'airthings_app_android';
};

export const useStoreUrl = (productUrl: string): string => {
  const storeLocale = useMemo(() => guessStoreUrl(navigator.languages), []);
  const utmSource = useMemo(() => guessUTMSource(navigator.platform), []);

  return `${BASE_URL}${storeLocale}/${productUrl}?utm_campaign=${UTM_CAMPAIGN}&utm_source=${utmSource}`;
};
